import React, { useEffect, useState } from 'react';
import { useApp } from '../context/AppContext';

export default function XpPopup() {
  const { state, dispatch } = useApp();
  const [visible, setVisible] = useState(false);
  const [amount, setAmount] = useState(0);
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    if (state.xpAnim > 0) {
      setAmount(state.xpAnim);
      setVisible(true);
      // Create floating particles
      setParticles(Array.from({length: 6}, (_, i) => ({
        id: i,
        x: Math.random() * 200 - 100,
        delay: i * 0.1,
      })));
      const t1 = setTimeout(() => setVisible(false), 2000);
      const t2 = setTimeout(() => {
        dispatch({ type: 'CLEAR_XP_ANIM' });
        setParticles([]);
      }, 2200);
      return () => { clearTimeout(t1); clearTimeout(t2); };
    }
  }, [state.xpAnim]);

  if (!visible) return null;

  return (
    <div style={{ position:'fixed', top:80, left:'50%', transform:'translateX(-50%)', zIndex:1000, pointerEvents:'none', textAlign:'center' }}>
      {/* Main XP badge */}
      <div style={{
        background:'linear-gradient(135deg, #FFD700, #FFA500)',
        color:'#000',
        borderRadius:999,
        padding:'10px 24px',
        fontSize:18,
        fontWeight:900,
        fontFamily:'var(--font-display)',
        boxShadow:'0 4px 20px rgba(255,165,0,0.6), 0 0 40px rgba(255,165,0,0.3)',
        animation:'bounceIn 0.4s cubic-bezier(0.36,0.07,0.19,0.97), fadeOut 0.3s 1.7s ease forwards',
        whiteSpace:'nowrap',
        letterSpacing:1,
      }}>
        ⚡ +{amount} XP
      </div>
      {/* Floating particles */}
      {particles.map(p => (
        <div key={p.id} style={{
          position:'absolute',
          top:0,
          left:`calc(50% + ${p.x}px)`,
          fontSize:16,
          animation:`floatUp 1s ${p.delay}s ease forwards`,
          opacity:0,
        }}>
          {['⭐','✨','💫','🌟','⚡','🔥'][p.id % 6]}
        </div>
      ))}
      <style>{`
        @keyframes fadeOut { to { opacity:0; transform:translateX(-50%) translateY(-15px); } }
      `}</style>
    </div>
  );
}